import { Link, useNavigate } from '@tanstack/react-router'
import { Button } from 'primereact/button'
import { Avatar } from 'primereact/avatar'
import { useAuth } from '@/api/hooks/useAuth'
import { n } from 'node_modules/@tanstack/query-core/build/modern/hydration-B_mC2U5v'

/**
 * ヘッダーコンポーネント
 *
 * ロゴと認証状態に応じたユーザー情報を表示
 */
function Header() {
  const navigate = useNavigate()
  const { isAuthenticated, user,logout } = useAuth()

  const handleLogout = async () => {
    window.location.href = '/api/auth/logout'
  }

  // ロゴコンポーネント
  const Logo = () => isAuthenticated ? (
    <Link to="/" className="flex align-items-center gap-2 no-underline logo">
      <div className="flex align-items-center flex-row gap-2">
        <img src="/logo_small.png" alt="εAI" />
      </div>
    </Link>
  ) : null

  // 認証状態に応じたユーザーメニュー
  const Menu = () => isAuthenticated ? (
    <div className="flex align-items-center gap-2 ml-auto">
      <div className="hidden md:flex flex-column align-items-end">
        <span className="font-medium">{user?.display_name ?? 'ユーザー'}</span>
        <span className="text-sm text-color-secondary">{user?.email ?? ''}</span>
      </div>
      <Avatar
        icon="pi pi-user"
        size="normal"
        shape="circle"
        className="bg-primary-100 text-primary-700"
      />
      <Button
        icon="pi pi-sign-out"
        tooltip="ログアウト"
        tooltipOptions={{ position: 'bottom' }}
        className="p-button-rounded p-button-text p-button-danger"
        onClick={handleLogout}
      />
    </div>
  ) : null

  return (
      isAuthenticated ? (
        <header className="shadow-2 z-2 flex justify-between align-items-center p-2">
          <Logo />
          <Menu />
        </header>
      ) : null
  )
}

export default Header
